import React, { useState } from "react";

export const FlujoEfectivoSemanal = ({ data }) => {
    const headers = data.length > 0 ? data[0] : null;
    const [collapsedTypes, setCollapsedTypes] = useState({});
    const [egresosCollapsed, setEgresosCollapsed] = useState(false);


    const toggleRow = (tipo) => {
        setCollapsedTypes((prevCollapsedTypes) => ({
            ...prevCollapsedTypes,
            [tipo]: !prevCollapsedTypes[tipo]
        }));
    };

    // Dentro de la función toggleEgresos
    const toggleEgresos = () => {
        setEgresosCollapsed(!egresosCollapsed);
    };
    
    return (
        <div className="esquema-financiero-container scroll">
        <table>
            <thead>
                <tr className="titulo-estado-flujo">
                    <th colSpan={26}>ESTADO DE FLUJO DE EFECTIVO</th>
                </tr>
                {headers && (
                    <tr>
                        <th rowSpan={2} colSpan={2} className="encabezado-conceptos">CONCEPTOS</th>
                        <th colSpan={4} className="encabezado-semanal">{headers.encabezado1}</th>
                        <th colSpan={4} className="encabezado-semanal">{headers.encabezado2}</th>
                        <th colSpan={4} className="encabezado-semanal">{headers.encabezado3}</th>
                        <th colSpan={4} className="encabezado-semanal">{headers.encabezado4}</th>
                        <th colSpan={4} className="encabezado-semanal">{headers.encabezado5}</th>
                        <th colSpan={4} className="encabezado-semanal">TOTAL</th>
                    </tr>
                )}       
                <tr>                     
                    <th className="encabezado-fijo">PROYECCION</th>
                    <th className="encabezado-fijo">REAL</th>
                    <th className="encabezado-fijo">VARIACION</th>
                    <th className="encabezado-fijo">%</th>
                    <th className="encabezado-fijo">PROYECCION</th>
                    <th className="encabezado-fijo">REAL</th>
                    <th className="encabezado-fijo">VARIACION</th>
                    <th className="encabezado-fijo">%</th>
                    <th className="encabezado-fijo">PROYECCION</th>
                    <th className="encabezado-fijo">REAL</th>
                    <th className="encabezado-fijo">VARIACION</th>
                    <th className="encabezado-fijo">%</th>
                    <th className="encabezado-fijo">PROYECCION</th>
                    <th className="encabezado-fijo">REAL</th>
                    <th className="encabezado-fijo">VARIACION</th>
                    <th className="encabezado-fijo">%</th>
                    <th className="encabezado-fijo">PROYECCION</th>
                    <th className="encabezado-fijo">REAL</th>
                    <th className="encabezado-fijo">VARIACION</th>
                    <th className="encabezado-fijo">%</th>
                    <th className="encabezado-fijo">PROYECCION</th>
                    <th className="encabezado-fijo">REAL</th>
                    <th className="encabezado-fijo">VARIACION</th>
                    <th className="encabezado-fijo">%</th>
                </tr>
            </thead>
            <tbody>
                <tr className="row-uno">
                    <td className="row-inicial">INGRESO INICIAL DISPONIBLE EN BANCOS</td>
                    <td className="row-inicial-cantidad">12312441</td>
                    <td colSpan={24}></td>
                </tr>
                
                        {data.map((item, index) => (
                            <React.Fragment key={index}>
                            {index === 0 || data[index - 1].tipo !== item.tipo ? (
                                <>
                                {data[index - 1]?.tipo === 'I' && item.tipo === 'C' && (
                                    <tr className="row-separacion">
                                        <td>.</td>
                                    </tr>
                                )}
                                {item.tipo === 'C' && (
                                    <tr className={`row-extra ${egresosCollapsed ? 'hidden' : ''}`} onClick={toggleEgresos}>
                                            <td className="row-tipo">(-) EGRESOS (SALIDAS)</td>
                                            <td className="row-inicial-cantidad">{item.proyeccion1}</td>
                                            <td className="row-cantidad-tipo">Dato1</td>
                                            <td className="row-cantidad-tipo">Dato2</td>
                                            <td className="row-cantidad-tipo">{item.proyeccion1}</td>
                                            <td className="row-cantidad-tipo">Dato1</td>
                                            <td className="row-cantidad-tipo">Dato2</td>
                                            <td className="row-cantidad-tipo">{item.proyeccion1}</td>
                                            <td className="row-cantidad-tipo">Dato1</td>
                                            <td className="row-cantidad-tipo">Dato2</td>
                                            <td className="row-cantidad-tipo">{item.proyeccion1}</td>
                                            <td className="row-cantidad-tipo">Dato1</td>
                                            <td className="row-cantidad-tipo">Dato2</td>
                                            <td className="row-cantidad-tipo">{item.proyeccion1}</td>
                                            <td className="row-cantidad-tipo">Dato1</td>
                                            <td className="row-cantidad-tipo">Dato2</td>
                                            <td className="row-cantidad-tipo">{item.proyeccion1}</td>
                                            <td className="row-cantidad-tipo">Dato1</td>
                                            <td className="row-cantidad-tipo">Dato2</td>
                                            <td className="row-cantidad-tipo">{item.proyeccion1}</td>
                                            <td className="row-cantidad-tipo">Dato1</td>
                                            <td className="row-cantidad-tipo">Dato2</td>
                                            <td className="row-cantidad-tipo">{item.proyeccion1}</td>
                                            <td className="row-cantidad-tipo">Dato1</td>
                                            <td className="row-cantidad-tipo">Dato2</td>
                                            <td className="row-cantidad-tipo">Dato2</td>
                                        </tr>
                                    )}
                                    <tr> <br></br> </tr>
                                <tr 
                                className={`row-extra ${collapsedTypes['(-) EGRESOS (SALIDAS)'] ? 'hidden' : ''}`}
                                onClick={() => toggleRow(item.tipo)}
                                >
                            <td className="row-tipo">
                                {(() => {
                                    let tipoConcepto = '';
                                    switch (item.tipo) {
                                        case 'I':
                                            tipoConcepto = "(+) INGRESOS (ENTRADAS)";
                                            break;
                                        case 'C':
                                            tipoConcepto = "(-) COMPRAS DE INVENTARIO - PAGO A PROVEEDORES";
                                            break;
                                        case 'G':
                                            tipoConcepto = "(-) GASTOS DE OPERACIÓN";
                                            break;
                                        case 'E':
                                            tipoConcepto = "(-) EGRESOS ADICIONALES";
                                            break;
                                        default:
                                            tipoConcepto = "no valido";
                                            break;
                                    }
                                    return tipoConcepto;
                                })()}
                            </td>
                            <td className="row-inicial-cantidad">{item.proyeccion1}</td>
                            <td className="row-cantidad-tipo">Dato1</td>
                            <td className="row-cantidad-tipo">Dato2</td>
                            <td className="row-cantidad-tipo">{item.proyeccion1}</td>
                            <td className="row-cantidad-tipo">Dato1</td>
                            <td className="row-cantidad-tipo">Dato2</td>
                            <td className="row-cantidad-tipo">{item.proyeccion1}</td>
                            <td className="row-cantidad-tipo">Dato1</td>
                            <td className="row-cantidad-tipo">Dato2</td>
                            <td className="row-cantidad-tipo">{item.proyeccion1}</td>
                            <td className="row-cantidad-tipo">Dato1</td>
                            <td className="row-cantidad-tipo">Dato2</td>
                            <td className="row-cantidad-tipo">{item.proyeccion1}</td>
                            <td className="row-cantidad-tipo">Dato1</td>
                            <td className="row-cantidad-tipo">Dato2</td>
                            <td className="row-cantidad-tipo">{item.proyeccion1}</td>
                            <td className="row-cantidad-tipo">Dato1</td>
                            <td className="row-cantidad-tipo">Dato2</td>
                            <td className="row-cantidad-tipo">{item.proyeccion1}</td>
                            <td className="row-cantidad-tipo">Dato1</td>
                            <td className="row-cantidad-tipo">Dato2</td>
                            <td className="row-cantidad-tipo">{item.proyeccion1}</td>
                            <td className="row-cantidad-tipo">Dato1</td>
                            <td className="row-cantidad-tipo">Dato2</td>
                            <td className="row-cantidad-tipo">Dato2</td>
                        </tr>
                        </>
                    ) : null}
                    {!collapsedTypes[item.tipo] && (
                    <tr className="row-flujo-efectivo" key={index}>
                        <td className="row-concepto">{item.concepto}</td>
                        <td className="row-inicial-cantidad">inicial</td>
                        <td className="row-cantidad">{item.proyeccion1}</td>
                        <td className="row-cantidad">{item.real1}</td>
                        <td className="row-cantidad">{item.variacion1}</td>
                        <td className="row-cantidad">{item.porcentaje1}</td>
                        <td className="row-cantidad">{item.proyeccion2}</td>
                        <td className="row-cantidad">{item.real2}</td>
                        <td className="row-cantidad">{item.variacion2}</td>
                        <td className="row-cantidad">{item.porcentaje2}</td>
                        <td className="row-cantidad">{item.proyeccion3}</td>
                        <td className="row-cantidad">{item.real3}</td>
                        <td className="row-cantidad">{item.variacion3}</td>
                        <td className="row-cantidad">{item.porcentaje3}</td>
                        <td className="row-cantidad">{item.proyeccion4}</td>
                        <td className="row-cantidad">{item.real4}</td>
                        <td className="row-cantidad">{item.variacion4}</td>
                        <td className="row-cantidad">{item.porcentaje4}</td>
                        <td className="row-cantidad">{item.proyeccion5}</td>
                        <td className="row-cantidad">{item.real5}</td>
                        <td className="row-cantidad">{item.variacion5}</td>
                        <td className="row-cantidad">{item.porcentaje5}</td>
                        <td className="row-cantidad">{item.proyecciontotal}</td>
                        <td className="row-cantidad">{item.realtotal}</td>
                        <td className="row-cantidad">{item.variaciontotal}</td>
                        <td className="row-cantidad">{item.porcentajetotal}</td>
                    </tr>
                    )}
                    </React.Fragment>
                ))}
                <tr className="row-separacion">
                    <td>.</td>
                </tr>
                    <tr className="row-final">
                        <td className="row-final">(=)INGRESO FINAL DISPONIBLE EN BANCOS</td>
                        <td className="row-cantidad-tipo">3</td>
                        <td className="row-cantidad-tipo">Dato1</td>
                        <td className="row-cantidad-tipo">Dato2</td>
                        <td className="row-cantidad-tipo">awd</td>
                        <td className="row-cantidad-tipo">Dato1</td>
                        <td className="row-cantidad-tipo">Dato2</td>
                        <td className="row-cantidad-tipo">awd</td>
                        <td className="row-cantidad-tipo">Dato1</td>
                        <td className="row-cantidad-tipo">Dato2</td>
                        <td className="row-cantidad-tipo">awd</td>
                        <td className="row-cantidad-tipo">Dato1</td>
                        <td className="row-cantidad-tipo">Dato2</td>
                        <td className="row-cantidad-tipo">awd</td>
                        <td className="row-cantidad-tipo">Dato1</td>
                        <td className="row-cantidad-tipo">Dato2</td>
                        <td className="row-cantidad-tipo">awd</td>
                        <td className="row-cantidad-tipo">Dato1</td>
                        <td className="row-cantidad-tipo">Dato2</td>
                        <td className="row-cantidad-tipo">adwda</td>
                        <td className="row-cantidad-tipo">Dato1</td>
                        <td className="row-cantidad-tipo">Dato2</td>
                        <td className="row-cantidad-tipo">daw</td>
                        <td className="row-cantidad-tipo">Dato1</td>
                        <td className="row-cantidad-tipo">Dato2</td>
                        <td className="row-cantidad-tipo">Dato2</td>
                    </tr>
            </tbody>
        </table>
        </div>
    );
};